import { MediaBoxComponent } from './mediabox';
import { Component, Injector, Input } from '@angular/core';
import { Events } from 'ionic-angular';
import { Domanda } from '../../app/domanda';
import { EthemeProvider } from '../../providers/etheme/etheme';
import { Domanda_super } from './domanda_super';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'aperta',
  templateUrl: 'aperta.html',
})

export class ApertaComponent extends Domanda_super {

  @Input('domanda') domanda: any;
  @Input('mq') mq: any;
  @Input('settingsmq') settingsmq: boolean;

  risp: any = '';
  feed = '';
  showconferma: boolean = true;
  showfeed: boolean = false;
  showtime: boolean = true;

  constructor(public events: Events, inj: Injector, public translate: TranslateService) {
    super(inj);
  }
  ngOnInit(): void {

    this.events.publish('start_tempo', this.domanda);
    if (this.domanda.durataMinima != '0') {
      this.showtime = false;
    }
    this.events.subscribe('tempo_' + this.domanda.id, (tipotempo) => {
      if (tipotempo == 'minima')
        this.showtime = true;
      else if (tipotempo == 'massima')
        this.conferma('tempo');
    });
  }

  prosegui() {
    this.events.publish('stop_tempo', this.domanda);
    this.events.publish('aperta', this.domanda, [this.risp]);
  }
  conferma(tempo?) {
    this.translate.get('domande.ERRDOMANDAAPERTA').subscribe(v => {
      if (this.risp == '' && tempo != 'tempo') {
        // this.showfeed = true;
        // this.feed = 'Devi rispondere alla domanda aperta';
        this.presentToast(v);
        return;
      }

      this.events.publish('stop_tempo_parziale', this.domanda);
      
      this.showconferma = false;
      this.feed = this.domanda.feedbackGenerico;
      if (this.settingsmq['istest'])
        this.prosegui();
    })
  }

  resize() {
    var x = document.getElementById("aperta_" + this.domanda.id);
    var element = x.children[0];
    var scrollHeight = element.scrollHeight;
    element.setAttribute('style', 'height:' + scrollHeight + 'px');
    x.style.height = (scrollHeight + 28) + 'px';
  }
  /*
    prosegui_t(){
      if (this.risp == '') {
        this.feed = 'Devi rispondere alla domanda aperta';
        return;
      }
  
    }
  */
}



// WEBPACK FOOTER //
// ./src/pages/msteps/aperta.ts